<template>
	<ul
		:class="[{
    'grid grid-flow-row': true,
    'sm:grid-cols-2': autoflow && filteredUsps.length >= 6
  }, gap]"
	>
		<li v-for="(usp, i) in filteredUsps" :key="i" class="relative pl-8 text-sm">
			<SvgIcon v-if="usp.icon" :name="usp.icon" class="text-primary absolute left-0 top-0.5" />
			<span v-html="usp.description"></span>
		</li>
	</ul>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import type { UspResource } from '@/api/resources';
import SvgIcon from '@/components/SvgIcon.vue';

export interface Props {
  usps: UspResource[]
  autoflow?: boolean,
  gap?: string
}

const props = withDefaults(defineProps<Props>(), {
  autoflow: false,
  gap: 'gap-3'
});

const filteredUsps = computed(() => props.usps.filter(usp => usp.description !== null));
</script>
